import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WebcamSnapshotComponent } from "./webcam-snapshot.component";
import { MatRippleModule } from "@angular/material/core";

@NgModule({
  imports: [CommonModule,MatRippleModule],
  declarations: [WebcamSnapshotComponent],
  exports: [WebcamSnapshotComponent]
})
export class WebcamSnapshotModule {}
